export default __webpack_public_path__ + "static/media/promo_05.acd07467.jpg";